import { FincasPlataformaService } from "../../../shared/generated/grpc/plataforma_terceros_fincas_pb";
import { FincaResumenResponse } from "../../../shared/response/terceros/FincaResumenResponse";
import { FincaPayload } from "../../../shared/services/api/payload/terceros/FincaPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/**
 * Alta y edición de finca (form de finca y cotización de Pipeline). Sin `cache`: el listado de fincas es
 * por cliente, así que el próximo `get()` de esa instancia trae la finca del servidor.
 */
export class FincaSaveService extends ServiceSaveBase<FincaResumenResponse, FincaPayload> {
  static readonly instance = new FincaSaveService();
  private constructor() { super(); }

  /**
   * gRPC-Web (`FincasPlataformaService.Guardar`): sin `id` crea, con `id` edita. Los campos `null`/ausentes
   * no viajan y el servidor conserva su valor. Devuelve el resumen que pinta la card.
   */
  protected async sendSave(payload: FincaPayload): Promise<FincaResumenResponse> {
    const f = await grpcCall(() => grpcClient(FincasPlataformaService).guardar({
      id: payload.id ?? undefined,
      clienteId: payload.clienteId,
      nombre: payload.nombre,
      tipo: payload.tipo ?? undefined,
      hectareasFinca: payload.hectareasFinca ?? undefined,
      hectareasProductivas: payload.hectareasProductivas ?? undefined,
      departamentoId: payload.departamentoId ?? undefined,
      municipioId: payload.municipioId ?? undefined,
      departamentoRegionId: payload.departamentoRegionId ?? undefined,
    }));
    return {
      id: f.id,
      isEliminado: false,
      nombreFinca: f.nombreFinca,
      municipioNombre: f.municipioNombre ?? null,
      departamentoNombre: f.departamentoNombre ?? null,
      hectareasFinca: f.hectareasFinca,
      cultivos: f.cultivos,
    };
  }
}
